import _ from 'lodash';

import { featureRoute } from '../helpers';
import { RoversRangersStages } from '../../constants/AppConstants';
import RoversRangersActions from '../../actions/RoversRangersActions';
import urls from '../../urls';

export default featureRoute('enableRoversRangers', RoversRangersStages.RESULTS, {
    getComponent(location, cb) {
        require.ensure([], (require) => {
            cb(null, require('../../components/roversRangers/Results').default);
        }, 'roversrangers-results');
    },

    onEnter (nextState, replace, callback) {
        const { params, location } = nextState;
        RoversRangersActions.loadFromParams(params, location.query).then((search) => {
            if (!search.isValid()) {
                replace(urls.location(RoversRangersStages.SEARCH));
            }
           _.defer(callback);
        });
    }
});
